/**
 * Cascading variant option_value ids for <high-variant-selects>.
 * Data comes from Liquid: script[data-variant-option-map] in product-variant-picker.liquid
 */
(function () {
  function refreshVariantOptionMap(element) {
    const script = element.querySelector("script[data-variant-option-map]");
    if (!script) {
      element.variantOptionMap = [];
      return;
    }
    try {
      element.variantOptionMap = JSON.parse(script.textContent);
    } catch (e) {
      element.variantOptionMap = [];
    }
  }

  function captureOptionValueIdsFromDom(element) {
    const rows = Array.from(
      element.querySelectorAll(
        ":scope > fieldset.product-form-input, :scope > div.product-form-input",
      ),
    );
    return rows
      .map((row) => {
        const radio = row.querySelector("input[type=radio]:checked");
        if (radio?.dataset?.optionValueId) return radio.dataset.optionValueId;
        const sel = row.querySelector("select.select-select");
        if (sel?.options?.length) {
          const opt = sel.options[sel.selectedIndex];
          return opt?.dataset?.optionValueId || "";
        }
        return "";
      })
      .filter(Boolean);
  }

  /**
   * When option 1 or 2 changes, DOM may still carry downstream selections from the previous combo.
   * Replace option_value ids with the first product variant that matches the new prefix.
   */
  function resolveOptionValueIdsAfterChange(map, changedIndex, domIds) {
    if (!map?.length) return domIds;

    const n = domIds.length;
    if (changedIndex >= n - 1) {
      return domIds;
    }
    const prefix = domIds.slice(0, changedIndex + 1);
    const first = map.find((v) =>
      prefix.every((id, i) => String(v.ids[i]) === String(id)),
    );
    return first ? first.ids.map(String) : domIds;
  }

  /**
   * @returns {string[]|null} null = use legacy updateOptions(target) in global.js
   */
  function resolveOptionValueIdsForChange(element, target) {
    refreshVariantOptionMap(element);
    const row = target.closest?.(
      "fieldset.product-form-input, .product-form-input",
    );
    const rows = Array.from(
      element.querySelectorAll(
        ":scope > fieldset.product-form-input, :scope > div.product-form-input",
      ),
    );
    const idx = row ? rows.indexOf(row) : -1;

    if (idx < 0 || !element.variantOptionMap?.length) {
      return null;
    }
    const domIds = captureOptionValueIdsFromDom(element);
    if (!domIds.length) {
      return null;
    }
    return resolveOptionValueIdsAfterChange(
      element.variantOptionMap,
      idx,
      domIds,
    );
  }

  /**
   * Look up a variant ID from the map using an array of option-value IDs aligned
   * with option positions (index 0 = position 1, etc.).  Pass null/undefined for
   * a position to skip matching it — useful when resolving multi-select combos
   * where one position is iterated externally.
   *
   * @param {Array} map         - element.variantOptionMap
   * @param {Array<string|null>} ids - option value IDs, positionally aligned
   * @returns {number|null}
   */
  function lookupVariantByOptionValueIds(map, ids) {
    if (!map?.length || !ids?.length) return null;
    const match = map.find((v) =>
      ids.every(
        (id, i) => id == null || String(v.ids[i]) === String(id),
      ),
    );
    return match?.id ?? null;
  }

  window.variantOptionMapHelpers = {
    refreshVariantOptionMap,
    captureOptionValueIdsFromDom,
    resolveOptionValueIdsAfterChange,
    resolveOptionValueIdsForChange,
    lookupVariantByOptionValueIds,
  };
})();
